import React from "react";
import { Tooltip, Typography } from "@mui/material";
import TriggerNodeTemplate from "../templates/TriggerNodeTemplate";

const scheduleTypeLabels = {
  immediate: "Immediate",
  oneTime: "One Time",
  recurring: "Recurring",
  daily: "Daily",
  weekly: "Weekly",
};

const formatActiveDays = (activeDays) => {
  if (!Array.isArray(activeDays) || activeDays.length === 0) {
    return "All days";
  }

  return activeDays.map((day) => day?.label || day).join(", ");
};

export default function SQLScheduleTriggerNode({ id, type, data }) {
  const scheduleType = data?.scheduleType?.value || data?.scheduleType || "immediate";
  const scheduleLabel = scheduleTypeLabels[scheduleType] || "Immediate";

  const scheduleDetails = (() => {
    if (scheduleType === "oneTime") {
      const start = data?.startDateTime || "Not set";
      const end = data?.endDateTime || "Not set";
      return `From ${start} to ${end}`;
    }
    if (scheduleType === "recurring") {
      const every = data?.recurringEvery || "";
      const unit = data?.recurringUnit?.value || data?.recurringUnit || "";
      const days = formatActiveDays(data?.activeDays);
      const range =
        data?.startDateTime && data?.endDateTime
          ? ` | ${data.startDateTime} - ${data.endDateTime}`
          : "";
      if (every && unit) return `Every ${every} ${unit} (${days})${range}`;
      return "Not set";
    }
    if (scheduleType === "daily") {
      const days = formatActiveDays(data?.activeDays);
      const dailyTime = data?.dailyTime || "";
      const range =
        data?.startDateTime && data?.endDateTime
          ? ` | ${data.startDateTime} - ${data.endDateTime}`
          : "";
      if (dailyTime) return `${dailyTime} (${days})${range}`;
      return "Not set";
    }
    if (scheduleType === "weekly") {
      const days = formatActiveDays(data?.activeDays);
      const weeklyTime = data?.weeklyTime || "";
      const range =
        data?.startDateTime && data?.endDateTime
          ? ` | ${data.startDateTime} - ${data.endDateTime}`
          : "";
      if (!weeklyTime) return "Not set";
      return `${days}${weeklyTime ? ` @ ${weeklyTime}` : ""}${range}`;
    }
    return "Runs on next queue cycle";
  })();

  return (
    <TriggerNodeTemplate id={id} type={type} data={data}>
      <Tooltip title={`Schedule: ${scheduleLabel}`} placement="top">
        <Typography sx={{ mt: 0.5 }} fontSize={8} noWrap>
          Schedule: {scheduleLabel}
        </Typography>
      </Tooltip>
      <Tooltip title={scheduleDetails} placement="bottom">
        <Typography fontSize={8} noWrap>
          {scheduleDetails}
        </Typography>
      </Tooltip>
    </TriggerNodeTemplate>
  );
}
